import {Utilities} from '@learningblocks/exp-constants';
const {DESIGN_NODE_TYPE} = Utilities;

export function viewFourSetStep(state, payload) {
  return {
    ...state,
    designChapter: updateDesignChapter(state.designChapter, payload),
  };
}

function updateDesignChapter(designChapter, payload) {
  let isStreakBroken = undefined;

  const updateInSlideTree = (slideTree) => {
    return slideTree.map((groupItem) => {
      return {
        ...groupItem,
        groupNodes: groupItem.groupNodes.map(updateGroupNode),
      };
    });
  };

  const updateGroupNode = (groupNode) => {
    return {
      ...groupNode,
      nodeComponents: updateNodeComponent(groupNode.nodeComponents),
    };
  };

  const updateNodeComponent = (nodeComponents) => {
    const correctNodeComponent = nodeComponents.find(
      (nodeComponent) =>
        nodeComponent.componentType === payload.componentType &&
        nodeComponent.answerId.includes(payload.optionId) &&
        !nodeComponent.answerId.includes(nodeComponent.droppedId)
    );
    const droppedNodeComponent = nodeComponents.find(
      (nodeComponent) =>
        nodeComponent.componentType === payload.componentType &&
        nodeComponent.droppedId === null
    );

    const swapCorrectAndDroppedNodeContents = () => {
      return nodeComponents.map((nodeComponent) => {
        if (nodeComponent.id === droppedNodeComponent.id) {
          return {
            ...correctNodeComponent,
            id: droppedNodeComponent.id,
            droppedId: payload.optionId,
            showTooltip: false,
          };
        } else if (nodeComponent.id === correctNodeComponent.id) {
          return {
            ...droppedNodeComponent,
            id: correctNodeComponent.id,
            droppedId: correctNodeComponent.droppedId,
          };
        } else return {...nodeComponent, showTooltip: false};
      });
    };

    const addToEmptyNodeIfExists = () => {
      return nodeComponents.map((nodeComponent) => {
        if (
          nodeComponent.componentType === payload.componentType &&
          nodeComponent.id === droppedNodeComponent.id
        )
          return {
            ...nodeComponent,
            droppedId: payload.optionId,
            showTooltip: true,
          };
        return {...nodeComponent, showTooltip: false};
      });
    };

    if (isStreakBroken === undefined) {
      if (correctNodeComponent && droppedNodeComponent) {
        isStreakBroken = false;
        return swapCorrectAndDroppedNodeContents();
      } else if (droppedNodeComponent) {
        isStreakBroken = true;
        return addToEmptyNodeIfExists();
      }
    }
    return nodeComponents.map((nodeComponent) => {
      return {...nodeComponent, showTooltip: false};
    });
  };

  const updateDroppedOptionVisibility = (optionItem) => {
    if (isStreakBroken === undefined) {
      return optionItem;
    }
    return {
      ...optionItem,
      list: optionItem.list.map((listItem) => {
        if (listItem.id === payload.optionId)
          return {...listItem, visible: false};
        return listItem;
      }),
    };
  };

  return {
    ...designChapter,
    currentView: {
      ...designChapter.currentView,
      slideTree: updateInSlideTree(designChapter.currentView.slideTree),
      options: designChapter.currentView.options.map(
        updateDroppedOptionVisibility
      ),
      ...updateCompleteFeedbackData(designChapter.currentView, isStreakBroken),
    },
    currentStreak: updateCurrentStreak(
      designChapter.currentStreak,
      isStreakBroken
    ),
    longestStreak: updateLongestStreak(designChapter, isStreakBroken),
  };
}

function updateCurrentStreak(currentStreak, isStreakBroken) {
  if (isStreakBroken != undefined) {
    if (isStreakBroken) return 0;
    else return currentStreak + 1;
  }
  return currentStreak;
}

function updateLongestStreak({currentStreak, longestStreak}, isStreakBroken) {
  if (
    isStreakBroken ||
    isStreakBroken === undefined ||
    longestStreak > currentStreak
  )
    return longestStreak;
  else return currentStreak + 1;
}

function updateCompleteFeedbackData({correctNodeComponents}, isStreakBroken) {
  if (correctNodeComponents != undefined) {
    if (isStreakBroken || isStreakBroken === undefined)
      return {correctNodeComponents};
    return {correctNodeComponents: correctNodeComponents + 1};
  }
  return {};
}
